import { useLandingStore } from "src/modules/pe-landing-module/data/store"
import doShoWPanelData from "../../../UIX/utils/doShowPanelData"
import { getLandingContainer } from "../../../utils/getLandingContainer"
import { SELECT_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { ID } from "src/libs/interfaces/layouts"

export const editMeat = ( sectionId: ID, meat_id: ID, selectType: SELECT_TYPE ) => {
    // return
    const landing       = getLandingContainer()
    // lock over sections
    landing.querySelectorAll(".landing-section-container.landing-gap").forEach(section => {
        const section_id = section?.getAttribute("id") || "" 
        if(section_id !== sectionId) {
            section?.classList.add("section-lock")
        }
    })

    // lock all outside element as exists
    landing.querySelector(".landing-content-edit-form")?.classList.add("d-none")
    landing.querySelector(".landing-content-click-form")?.classList.add("d-none")

    // lock all over elements in this section
    const section = landing.querySelector(`.landing-section-container.landing-gap[id="${sectionId}"]`)
    if( !!section ) {
        section.querySelector(".landing-section-edit-form")?.classList.add("d-none")
        section.querySelector(".landing-section-edit-container")?.classList.add("d-none")
        section.querySelector(".landing-section-marking-cont")?.classList.add("d-none")
        section.querySelector(".landing-section-top-padding-handler")?.classList.add("d-none")
        section.querySelector(".landing-section-bottom-padding-handler")?.classList.add("d-none")
        section.querySelector(".landing-section-container-handler")?.classList.add("d-none")
        section.querySelector(".landing-section-title-container")?.classList.add("section-lock")
        section.querySelector(".landing-section-bg-color")?.classList.add("section-lock")
        section.querySelector(".landing-section-bg-image")?.classList.add("section-lock")
        section.querySelector(".landing-delimiter")?.classList.add("section-lock")
        //section.querySelectorAll(".landing-floats-container").forEach((float: Element) => float.classList.add("section-lock"))
        const floats = landing.querySelectorAll(`.landing-section-container.landing-gap[id='${sectionId}'] > .landing-section > .landing-section-container > .landing-floats-container`)
        floats.forEach((float: Element) => float.classList.add("section-lock"))
        const meats = landing.querySelectorAll(`.landing-section-container.landing-gap[id='${sectionId}'] > .landing-section > .landing-section-container > .landing-data-components-container > div > div > .landing-content-container`)
         
        meats.forEach((meat: Element) => { 
            if(meat.getAttribute("data-content-id") !== meat_id){
                meat.classList.add("section-lock")
            } 
        })
    }
    
    useLandingStore.setState({
        editElement: {
            id: meat_id,
            sectionId,
            type: "string",
            selectType: selectType,
        }
    })
    doShoWPanelData("meat")
}